import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';
import * as XLSX from "xlsx";

const Failed = () => {

  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [serviceType, setServiceType] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  // Fetch Failed reports
  const getFailedReports = useCallback(async (offset, limit, email) => {
    try {
      let query = `?offset=${offset}&limit=${limit}`

      if (serviceType) {
        query += `&service_type=${serviceType}`
      }

      if (startDate && endDate) {
        query += `&start_date=${startDate}&end_date=${endDate}`
      }

      const response = await axios.get(`/request_log/failed${query}`);
      setPendingRequests(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, [serviceType, endDate, startDate]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getFailedReports((currentPage - 1) * recordsPerPage, recordsPerPage);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, getFailedReports]);


  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
    const excelData = pendingRequests.map((row) => {
      return {
        "MSISDN": row.msisdn,
        "Amount": row.amount,
        "Provider": row.provider,
        "Narration": row.narration,
        "Transaction Date": new Date(row.tran_date).toLocaleString("en-CA", { hour12: false }),
        "Created Date": new Date(row.date_created).toLocaleString("en-CA", { hour12: false }), 
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Failed Requests");
    XLSX.writeFile(workbook, "failed_requests.xlsx");
  };

  return (
    <div className='mx-auto p-4'>
      <h4 className="my-2"><b>Failed Requests</b></h4>
      <div className='bg-white rounded-lg p-4 w-full flex-1 min-w-0'>
        <div className="flex flex-wrap items-center justify-between py-2">
          <div>
            <select
              className='px-3 py-1 border bg-[#f2f9ff] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277]'
              value={serviceType}
              onChange={(e) => {setServiceType(e.target.value)}}
            >
              <option value=''>Service Type</option>
              <option value='2'>Airtime</option>
              <option value='5'>Bundle</option>
            </select>
          </div>
          <div>
            <button className='bg-[#134463] text-white px-4 py-1 rounded-lg hover:bg-[#165277]' onClick={handleExport}>Export</button>
          </div>
          <form className='flex items-center'>
            <label htmlFor="" className='p-2'>
              <span className='hidden'>Start Date</span>
              <input 
                type="date"
                className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                value={startDate}
                onChange={(e) => {setStartDate(e.target.value)}}
              />
            </label>
            <label htmlFor="" className='p-2'>
              <span className='hidden'>End Date</span>
              <input 
                type="date" 
                className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                value={endDate}
                onChange={(e) => {setEndDate(e.target.value)}}
              />
            </label>
          </form>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {pendingRequests.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>Phone Number</th>
                      <th className='p-2'>Account Number</th>
                      <th className='p-2'>Amount</th>
                      <th className='p-2'>Provider</th>
                      <th className='p-2'>Narration</th>
                      <th className='p-2'>Response</th>
                      <th className='p-2'>Transaction Date</th>
                      <th className='p-2'>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingRequests.map((request) => (
                      <tr key={request.id}>
                        <td className='p-2'>{request.msisdn}</td>
                        <td className='p-2'>{request.account_no}</td>
                        <td className='p-2'>{request.amount}</td>
                        <td className='p-2'>{request.provider}</td>
                        <td className='p-2'>{request.narration}</td>
                        <td className='p-2'>{request.response}</td>
                        <td className='p-2'>{new Date(request.tran_date).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2'>{new Date(request.date_created).toLocaleString("en-CA", { hour12: false })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <div>
            <span className='font-bold text-[#165277]'>Showing {count} / {total} records</span>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Failed;
